"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
var _Icon2 = require("../../../Icon");
var _Icon3 = _interopRequireDefault(_Icon2);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
var IconUserQuestion = /*#__PURE__*/
function (_Icon) {
  _inherits(IconUserQuestion, _Icon);
  function IconUserQuestion(props) {
    var _this;
    _classCallCheck(this, IconUserQuestion);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(IconUserQuestion).call(this, props));
    _this.name = 'IconUserQuestion';
    _this.icon = _react2.default.createElement("svg", {
      viewBox: "0 0 24 24",
      width: "1em",
      height: "1em",
      focusable: "false",
      "aria-hidden": "true",
      role: "presentation"
    }, _react2.default.createElement("g", {
      className: "user-question_svg__group0"
    }, _react2.default.createElement("path", {
      className: "user-question_svg__path0",
      d: "M15.501 23.998a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5h1c1.378 0 2.5-1.122 2.5-2.5v-3a.5.5 0 01.5-.5h2.813c-.174-.529-.342-1.063-.509-1.597-1.652-5.283-3.207-10.257-8.528-11.23a9.425 9.425 0 00-7.122 1.451A9.43 9.43 0 002.04 9.393a9.26 9.26 0 003.756 8.313.502.502 0 01.206.404v5.388a.5.5 0 01-1 0v-5.137a10.292 10.292 0 01-3.956-9.072 10.424 10.424 0 014.55-7.495A10.424 10.424 0 0113.463.188c5.91 1.081 7.63 6.58 9.292 11.897.168.536.336 1.073.508 1.607a.99.99 0 01-.24 1.008.99.99 0 01-.705.297h-2.316v2.5c0 1.93-1.57 3.5-3.5 3.5h-.5v2.5a.502.502 0 01-.501.501z"
    }), _react2.default.createElement("path", {
      className: "user-question_svg__path1",
      d: "M11.501 13.998a.5.5 0 01-.5-.5v-1.68a1.469 1.469 0 011.152-1.409 2.491 2.491 0 001.848-2.416 2.504 2.504 0 00-2.5-2.498 2.48 2.48 0 00-1.769.734 2.487 2.487 0 00-.731 1.769.5.5 0 11-.999.001 3.475 3.475 0 011.023-2.476 3.477 3.477 0 012.474-1.027 3.506 3.506 0 013.503 3.497 3.501 3.501 0 01-2.615 3.389.472.472 0 00-.386.449v1.668a.5.5 0 01-.5.499z"
    }), _react2.default.createElement("circle", {
      className: "user-question_svg__circle0",
      cx: 11.501,
      cy: 15.748,
      r: 0.75
    })));
    return _this;
  }
  return IconUserQuestion;
}(_Icon3.default);
exports.default = IconUserQuestion;